export const EndpointGroupParameters = {
    Wordpress: 'content', // todo: will update to wordpress (wait for update from Tina)
};

export const BasePaths = {
    Wordpress: `${EndpointGroupParameters.Wordpress}`,
};
